//#region src/kiosk_reduced_height_size.ts
let KioskReducedHeightSize = /* @__PURE__ */ function(KioskReducedHeightSize) {
	KioskReducedHeightSize["Small"] = "small";
	KioskReducedHeightSize["Medium"] = "medium";
	KioskReducedHeightSize["Large"] = "large";
	return KioskReducedHeightSize;
}({});
//#endregion
export { KioskReducedHeightSize };

//# sourceMappingURL=kiosk_reduced_height_size.js.map